import type { TFunction } from 'i18next'
import type { OperationResult } from '@/shared/api/operationResult'

/** Server texts are Uzbek only, so other languages get the panel's own wording. */
export function outcomeWarning(outcome: OperationResult, t: TFunction): string {
  return t('common.langCode', { defaultValue: '' }) === 'uz' ? outcome.message : t('operation.partialTitle')
}
